import { type AddToBagSummary, type Context, type SelectedProduct } from '../types';

// ─────────────────────────────────────────────────────────────────────────────

export function getAddToBagSummary(context: Context): AddToBagSummary {
  const { productAdds, selectedProducts } = context;

  const addedProductIds = selectedProducts
    .filter((selectedProduct) => productAdds.added.includes(selectedProduct.selectionId))
    .map(getProductId);

  const failedProductSlugs = selectedProducts
    .filter((selectedProduct) => productAdds.failed.includes(selectedProduct.selectionId))
    .map(getProductSlug);

  return {
    addedCount: productAdds.added.length,
    addedProductIds,
    failedProductSlugs,
  };
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

function getProductId(selectedProduct: SelectedProduct) {
  return selectedProduct.productId;
}

function getProductSlug(selectedProduct: SelectedProduct) {
  return selectedProduct.productSlug;
}
